<form [formGroup]="componentForm">
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label required">First Name</label>
		<div class="col-md-8 col-lg-9">
			<input type="text" class="e-input" formControlName="firstName" revFocusInput pmsCapitalizeFirstLetter/>
		</div>
	</div>
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label required">Last Name</label>
		<div class="col-md-8 col-lg-9">
			<input type="text" class="e-input" formControlName="lastName" pmsCapitalizeFirstLetter/>
		</div>
	</div>
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label">Middle Name</label>
		<div class="col-md-8 col-lg-9">
			<input type="text" class="e-input" formControlName="middleName" pmsCapitalizeFirstLetter/>
		</div>
	</div>
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label">Suffix</label>
		<div class="col-md-4 col-lg-5">
			<input type="text" class="e-input" formControlName="suffix" />
		</div>
		<div class="col-md-4">
			<span class="form-text">(eg. Jr, Sr)</span>
		</div>
	</div>
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label">Nickname</label>
		<div class="col-md-8 col-lg-9">
			<input type="text" class="e-input" formControlName="nickname" pmsCapitalizeFirstLetter/>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'familyDemographicsDateOfBirthFormGroup'">
		<label class="col-md-4 col-lg-3 col-form-label required">DOB</label>
		<div class="col-md-8 col-lg-9">
			<ejs-datepicker placeholder="mm/dd/yyyy"
							formControlName="dob"
							[format]="dateFormat">
			</ejs-datepicker>
		</div>
	</div>
	<div class="row mb-3" *pmsUsaOnly>
		<label class="col-md-4 col-lg-3 col-form-label">SSN</label>
		<div class="col-md-8 col-lg-9">
			<ejs-maskedtextbox mask="000-00-0000"
							   formControlName="ssn">
			</ejs-maskedtextbox>
		</div>
	</div>
	<div class="row mb-3" *pmsCanadaOnly>
		<label class="col-md-4 col-lg-3 col-form-label">SIN/PHN</label>
		<div class="col-md-8 col-lg-9">
			<input class="e-input" type="text" formControlName="sin" pmsSinInput/>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'familyDemographicsSexFormGroup'">
		<label class="col-md-4 col-lg-3 col-form-label required">Sex</label>
		<div class="col-md-8 col-lg-9">
			<pms-enum-select-button [enumList]="genderOptions"
									formControlName="gender"></pms-enum-select-button>
		</div>
	</div>
</form>
